/** @format */

import { ICategories } from "../../store/reducers/categories/interfaces";

export const subcat: ICategories[] = [
  {
    id: 1,
    name: "Wszystkie",
    categorySection: 1,
    sizeBook: null,
    sizeWork:null,
  },
  {
    id: 2,
    name: "Teczki",
    categorySection: 2,
    sizeBook: null,
    sizeWork:null,
  },

  {
    id: 3,
    name: "Pozostale",
    categorySection: 3,
    sizeBook: null,
    sizeWork:null,
  },
];
